<template>
  <div>
    <v-container>
      <date-filter
        @changeDate="onDateChanged"
        v-model="selectedDate"
        :defaultFilter="'last_7_days'"
      ></date-filter>
      <div class="py-3 text-xs-right">
        <v-btn dark outline color="primary" @click="showManage = true"> Add </v-btn>
      </div>
      <v-data-table
        hide-actions
        :loading="loading"
        :headers="headers"
        :items="announcementData"
        :pagination.sync="pagination"
        class="elevation-1 mt-3"
      >
        <template v-slot:items="props">
          <tr>
            <td>{{ props.item.announce_type }}</td>
            <td>{{ props.item.affiliation || '-' }}</td>
            <td>{{ props.item.division || '-' }}</td>
            <td>{{ props.item.department || '-' }}</td>
            <td>{{ getDateFormatted(props.item.start_date) }}</td>
            <td>{{ getDateFormatted(props.item.end_date) }}</td>
            <!-- <td>{{ formattedMessage(props.item.a_val) }}</td> -->
            <td>
              <v-btn outline fab small color="primary" @click="onEditAnnouncement(props.item)">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn outline fab small color="primary" @click="onCopy(props.item)">
                <em class="fas fa-copy" />
              </v-btn>
              <v-btn outline fab small color="primary" @click="onDeleteAnnouncement(props.item.id)">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="mt-2">
        <v-pagination
          :total-visible="6"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
      </div>

      <v-dialog v-model="showManage" persistent width="850px">
        <AutoAnnouncementManage
          v-if="showManage"
          v-model="selectedAnnouncement"
          @close="onCloseManage"
          @success="onSuccessManage"
          :divisionMasterData="divisionMasterData"
          :departmentMasterData="departmentMasterData"
          :affiliationMasterData="affiliationMasterData"
        >
        </AutoAnnouncementManage>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import hopinnHrApi from '@/api/hopinn-hr'
import { mapGetters } from 'vuex'
import moment from 'moment'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import AutoAnnouncementManage from './AutoAnnouncementManage.vue'

export default {
  props: ['divisionMasterData', 'departmentMasterData', 'affiliationMasterData'],
  components: {
    DateFilter,
    AutoAnnouncementManage
  },
  data() {
    return {
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      loading: false,
      announcementData: [],
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      headers: [
        { text: 'ประเภทการแจ้งเตือน', value: 'announce_type' },
        { text: 'สังกัด', value: 'affiliation' },
        { text: 'สาขา', value: 'division' },
        { text: 'แผนก', value: 'department' },
        { text: 'Start Date', value: 'start_date' },
        { text: 'End Date', value: 'end_date' },
        // { text: "Message", value: 'postion', sortable: false },
        { text: '', value: '', sortable: false }
      ],
      tags: [],
      masterData: [],
      showManage: false,
      selectedAnnouncement: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const vm = this
      try {
        let data = {
          pageid: vm.selectedBot.pageid,
          limit: vm.limit,
          offset: vm.offset,
          start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
          end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD')
        }
        vm.loading = true
        const response = await hopinnHrApi.getAnnouncementList({
          config: {
            params: data
          }
        })
        vm.loading = false
        if (response && response.data.responsecode == 200) {
          vm.announcementData = response.data.data
          vm.total = response.data.total
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    changePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit

        vm.getData()
      }
    },
    onCloseManage() {
      this.showManage = false
      this.selectedAnnouncement = null
    },
    onEditAnnouncement(item) {
      this.showManage = true
      this.selectedAnnouncement = item
    },
    onSuccessManage() {
      this.showManage = false
      this.getData()
    },
    onDeleteAnnouncement(id) {
      this.$swal
        .fire({
          icon: 'error',
          text: 'คุณต้องการลบใช่หรือไม่',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        })
        .then((result) => {
          if (result.value) {
            this.deleteAnnouncement(id)
          }
        })
    },
    async deleteAnnouncement(id) {
      const vm = this
      try {
        let data = {
          pageid: vm.selectedBot.pageid,
          id: id
        }
        const response = await hopinnHrApi.deleteAnnouncement({ data: data })
        if (response && response.data.responsecode == 200) {
          await this.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          vm.getData()
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    onCopy(item) {
      const vm = this
      vm.$swal
        .fire({
          title: 'คุณต้องการจะคัดลอกข้อมูลใช่หรือไม่',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            vm.loading = true
            vm.createAnnouncement(item)
          }
        })
    },
    async createAnnouncement(item) {
      const vm = this
      try {
        let data = {
          pageid: vm.selectedBot.pageid,
          announce_type: item.announce_type,
          division: item.division,
          department: item.department,
          affiliation: item.affiliation,
          start_date: moment(item.start_date).format('YYYY-MM-DD'),
          end_date: moment(item.end_date).format('YYYY-MM-DD'),
          a_val: item.a_val,
          active: true
        }
        const response = await hopinnHrApi.createAnnouncement({ data })
        vm.loading = false
        if (response && response.data.responsecode == 200) {
          vm.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          vm.getData()
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    getDateFormatted(val) {
      return val ? moment(val).format('DD/MM/YYYY') : '-'
    },
    onDateChanged() {
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/HopinnHr/AutoAnnouncement.vue